import { defineStore } from 'pinia'

export const useCacheStore = defineStore('cache', {
  state: () => ({
    cache: null,
  }),
  getters: {
    hasCache: state => !!state.cache,
  },
  actions: {
    setCache(cache) { // If fetching profile separately later
      this.cache = cache
    },
  },
  persist: {
    storage: typeof window !== 'undefined' ? localStorage : undefined, // Or sessionStorage
  },
})
